import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

export type SettlementProductDataType = Partial<ApiSchema["SettlementProduct"]["type"] & EDocumentProductDataType>;
export const SettlementProductApi = new GenericModelApi<"SettlementProduct", SettlementProductDataType>("SettlementProduct", "codigo");